import StudioExternalToolAPI from 'dashboard/api/studio/externalTool';
import { createStore } from '../captain/storeFactory';

export default createStore({
  name: 'StudioExternalTool',
  API: StudioExternalToolAPI,
});
